import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ActivePaperProductTypes } from 'helpers/productPrice/productOptions';
import { getDiscountVsRetail, getProductPrice, showPrice, } from 'helpers/productPrice/productPrices';
import { finalPrice, getAppliedPromo } from 'helpers/productPrice/promotions';
import { sendTrackingEventsOnClick, sendTrackingEventsOnView, } from 'helpers/productPrice/subscriptions';
import { paperCheckoutUrl } from 'helpers/urls/routes';
import { getTitle } from '../helpers/products';
import { PaperPrices } from './content/paperPrices';
// ---- Helpers ----- //
const getPriceCopyString = (price, productCopy = null) => {
    const promotion = getAppliedPromo(price.promotions);
    if (promotion?.numberOfDiscountedPeriods) {
        return (_jsxs(_Fragment, { children: ["per month for ", promotion.numberOfDiscountedPeriods, " months", productCopy, ", then ", showPrice(price), " after"] }));
    }
    return _jsxs(_Fragment, { children: ["per month", productCopy] });
};
const getOfferText = (price, promo) => {
    if (promo && price.savingVsRetail && promo.discount?.amount) {
        const discount = getDiscountVsRetail(price.price, price.savingVsRetail, promo.discount.amount);
        if (discount > 0) {
            return `Save ${discount}% on retail price`;
        }
        else {
            return '';
        }
    }
    if (price.savingVsRetail && price.savingVsRetail > 0) {
        return `Save ${price.savingVsRetail}% on retail price`;
    }
    return '';
};
const getUnavailableOutsideLondon = (fulfilmentOption, productOption) => fulfilmentOption === 'HomeDelivery' &&
    (productOption === 'Saturday' || productOption === 'Sunday');
// ---- Plans ----- //
const copy = {
    HomeDelivery: {
        Everyday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), " and ", _jsx("strong", { children: "the Observer" }), ", delivered"] })),
        Sixday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), ", delivered"] })),
        Weekend: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), " and ", _jsx("strong", { children: "the Observer" }), ", delivered"] })),
        Saturday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), ", delivered"] })),
        Sunday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Observer" }), ", delivered"] })),
    },
    Collection: {
        Everyday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), " and ", _jsx("strong", { children: "the Observer" })] })),
        Sixday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" })] })),
        Weekend: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" }), " and ", _jsx("strong", { children: "the Observer" })] })),
        Saturday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Guardian" })] })),
        Sunday: (_jsxs(_Fragment, { children: [' ', "for ", _jsx("strong", { children: "the Observer" })] })),
    },
};
const getPlans = (fulfilmentOption, productPrices) => ActivePaperProductTypes.map((productOption) => {
    const priceAfterPromosApplied = finalPrice(productPrices, 'GB', 'Monthly', fulfilmentOption, productOption);
    const promotion = getAppliedPromo(priceAfterPromosApplied.promotions);
    const promoCode = promotion ? promotion.promoCode : null;
    const trackingProperties = {
        id: `subscribe_now_cta-${[productOption, fulfilmentOption].join()}`,
        product: 'Paper',
        componentType: 'ACQUISITIONS_BUTTON',
    };
    const nonDiscountedPrice = getProductPrice(productPrices, 'GB', 'Monthly', fulfilmentOption, productOption);
    const labelText = productOption === 'Everyday' ? 'Best Deal' : '';
    return {
        title: getTitle(productOption),
        price: showPrice(priceAfterPromosApplied),
        href: paperCheckoutUrl(fulfilmentOption, productOption, promoCode),
        onClick: sendTrackingEventsOnClick(trackingProperties),
        onView: sendTrackingEventsOnView(trackingProperties),
        buttonCopy: 'Subscribe',
        priceCopy: getPriceCopyString(nonDiscountedPrice, copy[fulfilmentOption][productOption]),
        offerCopy: getOfferText(priceAfterPromosApplied, promotion),
        label: labelText,
        unavailableOutsideLondon: getUnavailableOutsideLondon(fulfilmentOption, productOption),
    };
});
function PaperProductPrices({ productPrices, tab, setTabAction, }) {
    if (!productPrices) {
        return null;
    }
    const products = getPlans(tab, productPrices);
    return (_jsx(PaperPrices, { activeTab: tab, products: products, setTabAction: setTabAction }));
}
// ----- Exports ----- //
export default PaperProductPrices;
